import { DecimalPipe } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({ name: 'pricePrepayment' })
export class PricePrepaymentPipe implements PipeTransform {
  constructor(@Inject(BALANCE_TOKEN) public balance: Observable<Balance>, private numberPipe: DecimalPipe) {}

  transform(value: string | number, period: string = null, digitsInfo = '1.2-2'): Observable<string> {
    return this.balance.pipe(
      switchMap((balance) => {
        const currency = balance?.subscriptionCurrencySign || '$';

        if (isNil(value)) {
          return '—';
        }

        const roundedValue = this.numberPipe.transform(value || 0, digitsInfo, 'en');

        return of(period ? `${currency}${roundedValue}/${period}` : `${currency}${roundedValue}`);
      })
    );
  }
}
